module.exports = false;



//////////////////
// WEBPACK FOOTER
// /Users/kny/EHG/ABY2/ABYTWO/abydos/ng-project/node_modules/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = polyfills